/** @type {import("@mui/material").SxProps<typeof import('@mui/material/styles').Theme>} */

import { BANNER_BACKGROUND } from '../../shared/Constants';

const { DARK } = BANNER_BACKGROUND;
const useStyles = (
  theme,
  backgroundMobile,
  backgroundTablet,
  backgroundDesktop,
  foregroundMobile,
  foregroundDesktop,
  foregroundTablet,
  bannerBackground
) => ({
  bannerContainer: {
    minHeight: '18.75rem',
    height: 'auto',

    [theme.breakpoints.down('sm')]: {
      minHeight: '30.75rem',
      background: `url(${backgroundMobile}) no-repeat center/cover`,
      backgroundColor:
        bannerBackground === DARK
          ? theme?.palette?.secondary?.mobileActiveToggleBackgroundLight
          : theme?.palette?.primary?.backgroundColor4,
      marginBottom: '0.5rem',
    },
    [theme.breakpoints.up('sm')]: {
      background: `url(${backgroundTablet}) right/cover no-repeat`,
      backgroundColor:
        bannerBackground === DARK
          ? theme?.palette?.secondary?.mobileActiveToggleBackgroundLight
          : theme?.palette?.primary?.backgroundColor4,
    },
    [theme.breakpoints.up('md')]: {
      background: `url(${backgroundDesktop}) 100% 100%/cover no-repeat `,
      backgroundColor:
        bannerBackground === DARK
          ? theme?.palette?.secondary?.mobileActiveToggleBackgroundLight
          : theme?.palette?.primary?.backgroundColor4,
      marginBottom: '2.5rem',
    },
  },
  bannerForeGround: {
    height: '100%',
    [theme.breakpoints.down('sm')]: {
      width: '18.75rem',
      minHeight: '18.75rem',
      margin: '0 auto',
      background: `url(${foregroundMobile}) center top/100% 100% no-repeat`,
    },
    [theme.breakpoints.up('sm')]: {
      width: '18.75rem',
      minHeight: '18.75rem',
      margin: '0 auto',
      background: `url(${foregroundDesktop}) center top/100% 100% no-repeat`,
    },
    [theme.breakpoints.up('md')]: {
      background: `url(${foregroundTablet}) center top/100% 100% no-repeat`,
    },
  },
  bannerDetails: {
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      alignItems: 'flex-start',
    },
  },
  bannerBoxContainer: {
    m: '0 auto',
    p: '0 1.5rem',
    justifyContent: 'space-between',
    [theme.breakpoints.down('sm')]: {
      p: 0,
    },
  },
  bannerBox: {
    display: 'flex',
    flexDirection: 'column',

    [theme.breakpoints.down('sm')]: {
      textAlign: 'center',
      p: '1.5rem 1rem 0 1rem',
    },
    [theme.breakpoints.between('sm', 'md')]: {
      p: '1.5rem 1rem 0 1rem',
    },
  },
  bannerTitle: {
    color:
      bannerBackground === DARK
        ? theme?.palette?.primary?.textColor2
        : theme?.palette?.primary?.textColor3,
    letterSpacing: 'inherit',
  },
  bannerDescription: {
    pt: '1rem',
    color:
      bannerBackground === DARK
        ? theme?.palette?.primary?.textColor2
        : theme?.palette?.primary?.textColor3,
    letterSpacing: 'inherit',
    [theme.breakpoints.down('sm')]: {
      p: '2rem 2rem 0 2rem',
    },
  },
  bannerCTA: {
    pt: '1.5rem',
    [theme.breakpoints.down('sm')]: {
      p: '2rem 3rem 0 3rem',
    },
  },
});

export default useStyles;
